import { render, staticRenderFns } from "./NewMerchant.vue?vue&type=template&id=f2c5e480"
import script from "./NewMerchant.vue?vue&type=script&lang=js"
export * from "./NewMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports